__turbopack_context__.v({
  "inputContainer": "DeleteConfirmation-module__SUBkpq__inputContainer",
});
